module.exports = __webpack_public_path__ + "static/media/log_9.4dee862f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/log_9.jpg
// module id = 1898
// module chunks = 0